import React from "react";
import { Form } from "react-bootstrap";

const CheckBoxFormik = ({ formik, field, label, inline }) => (
  <>
    <Form.Check
      id={field}
      name={field}
      label={label}
      inline={inline}
      checked={formik.values[field]}
      disabled={formik.isSubmitting}
      onChange={formik.handleChange}
      isInvalid={formik.touched[field] && formik.errors[field]}
    />
    {formik.touched[field] && formik.errors[field] && (
      <Form.Control.Feedback type="invalid">{formik.errors[field]}</Form.Control.Feedback>
    )}
  </>
);

export default CheckBoxFormik;
